export default __webpack_public_path__ + "static/media/delivering.3851b7c1.svg";